import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import GenericDrawerComp from "./GenericDrawerComp";


const GenericOverviewSideCard = ({
  showMoreModal=false,
  setShowMoreModal=()=>{},
  titleForSideCard,
  comp = <></>,
  minWidthForDrawer,
  disableXbtn,
  onModalClose=()=>{}
}) => {
  return (
  <div className="row">
      <GenericDrawerComp
        open={showMoreModal}
        onClose={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowMoreModal(false);onModalClose()}}
        titleForSideCard={titleForSideCard}
        minWidthForDrawer={minWidthForDrawer}
        disableXbtn={disableXbtn}
      >
        {comp}
      </GenericDrawerComp>
    </div>
  );
};

export default React.memo(GenericOverviewSideCard);
